import React from 'react';
import { updateSinkInfo } from 'js/actions';
import ResourceDetailHeader from 'js/components/ResourceDetailHeader/ResourceDetailHeader';
import DataSinkDetailActionsContainer from 'js/components/data_sinks/cards/DataSinkDetailActionsContainer';
import { RESOURCE_TYPE_SINK } from 'js/constants/resourceTypes';
import { Stack } from 'new/elements/Stack';
import ViewEntityPipelineButtonContainer from 'js/components/pipelines/cards/ViewEntityPipelineButtonContainer';
import { SearchFilterTypes } from 'js/constants/visibilityFilters';
import PipelineStatusBadge, {
  Status,
} from 'new/components/pipelines/PipelineStatusChip/PipelineStatusChip';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import useAppDispatch from 'js/hooks/useAppDispatch';
import Typography from 'new/elements/Typography';

interface DataSinkDetailHeaderProps {
  readOnly: boolean;
  adminAccess: boolean;
  hideActions: boolean;
  data: any;
  isManaged: any;
  showPipelineButton?: boolean;
  onCloseDrawer?(): void;
}

const Connection = ResourceDetailHeader.TopContent.Connection;
const ViewFlowButton = ResourceDetailHeader.TopContent.ViewFlowButton;

export const DataSinkDetailHeader = (props: DataSinkDetailHeaderProps) => {
  const { readOnly, adminAccess, hideActions, data, isManaged, showPipelineButton = true } = props;
  const dispatch = useAppDispatch();

  const updateInfo = (id, info) => {
    dispatch(updateSinkInfo(data.id, info));
  };

  const isLLM = data.node_type === 'llm_processor' || data.flow_type === 'rag';

  return (
    <ResourceDetailHeader
      readOnly={readOnly}
      adminAccess={adminAccess}
      data={data}
      updateInfo={updateInfo}
      onCloseDrawer={props?.onCloseDrawer}
    >
      <ResourceDetailHeader.TopContent>
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap="16px">
          <Stack direction="row" alignItems="center" gap="16px">
            {isLLM ? (
              <ResourceDetailHeader.TopContent.ConnectionBox>
                <Typography>LLM Processor</Typography>
              </ResourceDetailHeader.TopContent.ConnectionBox>
            ) : (
              <Connection resourceType={RESOURCE_TYPE_SINK} data={data} />
            )}
            <ChipWithCopy tooltipTitle="Copy Destination ID" toCopy={data.id}>
              ID {data.id}
            </ChipWithCopy>
            <PipelineStatusBadge
              id={data.id}
              status={data.status as Status}
              runtimeStatus={data?.runtime_status}
              ingestionMode={data.ingestion_mode}
              parentArchivalStatus={data?.archival_status}
            />
          </Stack>
          <Stack direction="row" alignItems="center" gap="16px">
            {showPipelineButton && (
              <ViewEntityPipelineButtonContainer
                filterType={SearchFilterTypes.DESTINATION_ID}
                filterValue={data.id}
                className={'view-entity-pipeline-button-position'}
                ButtonComponent={<ViewFlowButton />}
              />
            )}
            {!hideActions && !isLLM && (
              <DataSinkDetailActionsContainer
                data={data}
                showStatus={false}
                readOnly={readOnly}
                isManaged={isManaged}
                hideMenuDetails={true}
              />
            )}
          </Stack>
        </Stack>
      </ResourceDetailHeader.TopContent>
    </ResourceDetailHeader>
  );
};
